module.exports = __webpack_public_path__ + "static/media/relembrando-partitura.c7f99acd.png";